import { render, staticRenderFns } from "./IconSvgIdea.vue?vue&type=template&id=190240ef&scoped=true&"
import script from "./IconSvgIdea.vue?vue&type=script&lang=js&"
export * from "./IconSvgIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190240ef",
  null
  
)

export default component.exports